import * as React from "react";
const SvgSwitchBasicDefault = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={56} height={40} fill="none" {...props}>
    <rect width={52} height={32} x={2} y={4} fill="#C8C8C8" rx={16} />
  </svg>
);
export default SvgSwitchBasicDefault;
